import { render, staticRenderFns } from "./Technician.vue?vue&type=template&id=062f5667&scoped=true&lang=html&"
import script from "./Technician.vue?vue&type=script&lang=js&"
export * from "./Technician.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "062f5667",
  null
  
)

export default component.exports